// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 取消导出 POST /backend/download/cancel_download */
export async function postBackendDownloadCancelDownload(
  body: API.CancelDownloadParams,
  options?: { [key: string]: any },
) {
  return request<API.CancelDownloadResult>('/backend/download/cancel_download', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 导出中心 POST /backend/download/get_download_list */
export async function postBackendDownloadGetDownloadList(
  body: API.GetDownloadListParams,
  options?: { [key: string]: any },
) {
  return request<API.GetDownloadListResult>('/backend/download/get_download_list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除打印模板配置 POST /common/config/delete_print_config */
export async function postCommonConfigDeletePrintConfig(
  body: API.DeletePrintConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.DeletePrintConfigResult>('/common/config/delete_print_config', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取公共配置 POST /common/config/get_common_config */
export async function postCommonConfigGetCommonConfig(
  body: API.GetCommonConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.GetCommonConfigResult>('/common/config/get_common_config', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 公告详情 POST /common/config/get_notice_detail */
export async function postCommonConfigGetNoticeDetail(
  body: API.GetNoticeDetailParams,
  options?: { [key: string]: any },
) {
  return request<API.GetNoticeDetailResult>('/common/config/get_notice_detail', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 公告列表 POST /common/config/get_notice_list */
export async function postCommonConfigGetNoticeList(
  body: API.GetNoticeListParams,
  options?: { [key: string]: any },
) {
  return request<API.GetNoticeListResult>('/common/config/get_notice_list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取打印模板配置 POST /common/config/get_print_config */
export async function postCommonConfigGetPrintConfig(
  body: API.GetPrintConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.GetPrintConfigResult>('/common/config/get_print_config', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取web小红点 POST /common/config/get_red_num */
export async function postCommonConfigGetRedNum(
  body: API.GetRedNumParams,
  options?: { [key: string]: any },
) {
  return request<API.GetRedNumResult>('/common/config/get_red_num', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 行为上报 POST /common/config/page_action */
export async function postCommonConfigPageAction(
  body: API.PageActionParams,
  options?: { [key: string]: any },
) {
  return request<API.PageActionResult>('/common/config/page_action', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 保存打印模板配置 POST /common/config/save_print_config */
export async function postCommonConfigSavePrintConfig(
  body: API.SavePrintConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.SavePrintConfigResult>('/common/config/save_print_config', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
